import { useEffect, useState } from "react";
import api from "@/lib/api";

// Editable question blueprint (counts, difficulty, weights, guidance) plus whether the timer is enforced.
export function useBlueprint(jobId) {
  const [config, setConfig] = useState(null);
  const [timed, setTimed] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/jobs/${jobId}/question-agent`).then(({ data }) => setConfig(data)).catch(() => setError("Could not load the blueprint."));
    api.get(`/jobs/${jobId}`).then(({ data }) => setTimed((data.assessment_time_limit_min || 0) > 0)).catch(() => {});
  }, [jobId]);

  const set = (key, value) => setConfig((c) => ({ ...c, [key]: value }));
  const total = config ? config.mcq_count + config.subjective_count : 0;
  const weight = config ? config.competencies.reduce((n, c) => n + (Number(c.weight) || 0), 0) : 0;
  const countValid = !!config && total >= 1 && total <= 30 && config.easy + config.medium + config.hard === total;
  const names = config ? config.competencies.map((c) => c.name.trim().toLowerCase()) : [];
  const valid = countValid && weight === 100 && names.length <= total && names.every(Boolean) && new Set(names).size === names.length;

  const save = async () => {
    setError("");
    try {
      await api.put(`/jobs/${jobId}/question-agent`, config);
      await api.patch(`/jobs/${jobId}/assessment-settings`, { time_limit_min: timed ? config.duration_min : 0 });
      return true;
    } catch (e) {
      const d = e.response?.data?.detail;
      setError(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join("; ") : "Could not save the blueprint.");
      return false;
    }
  };
  return { config, set, total, weight, countValid, valid, timed, setTimed, save, error };
}
